import React, { useState, useEffect } from "react";
import {
    Container, Box, Typography, Button, TextField, Select, MenuItem, InputLabel,
    FormControl, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, IconButton, Icon, Pagination, InputAdornment, Dialog, DialogTitle, DialogContent,
    DialogActions, Tooltip
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import Loader from "../../components/Loader";
import Header from "../../components/header";
import Footer from "../../components/footer";
import { withTranslation } from "react-i18next";
import { Search, List, GridView, StarOutline, Star, Share, Delete, Edit, Close, Save, Cancel } from "@mui/icons-material";
import axios from "axios";
import { GetDashboardGroupListSearchUrl, DeleteActionUrl, getFillListUrl, countryActionID, dashboardGroupCountryActionID } from "../../utils/constants";
import CommonPagination from "../../components/CommonPagination";
import { axiosDelete, axiosGet, axiosPost } from "../../utils/Axios";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../components/toast';
import { HeaderBlock } from "@colliers/colliers-b2c";

//shayd shifa maam merge nhi liye
const DashboardGroupList = (_props) => {
    //constructor(props) {
    //    super(props);
    //    this.state = {
    //        isLoading: false,
    //    };
    //}
    const { ToastComponent, showToast } = useToast();
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
   
    const [dropdownList, setDropdownList] = useState([]);
    
    const [countryID, setcountryID] = useState("0");
    const [groupName, setGroupName] = useState("");
    const [dashboardGroup,setdashboardGroup ]= useState(null);
    const [status, setStatus] = useState("Active");

    const handleGroupNameChange = (event) => {
        setGroupName(event.target.value);
    };
    const handleStatusChange = (event) => {
        setStatus(event.target.value);
    };

    // Handle change event
    const handleChange = (event) => {
        setcountryID(event.target.value);
        console.log("Selected Value:", event.target.value);
    };
    //render() {
    //const { isLoading } = this.state;
    const navigate = useNavigate();
    const [reset, setReset] = useState(false);
    const [dashboardGroupList, setdashboardGroupList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [filteredDashboardGroups, setFilteredDashboardGroups] = useState(dashboardGroupList)
    const listItemsPerPage = 10;
    const totalItems = filteredDashboardGroups?.length;
    const startIndex = (currentPage - 1) * listItemsPerPage;
    const paginatedDashboardGroups = filteredDashboardGroups?.slice(startIndex, startIndex + listItemsPerPage);

    useEffect(() => {
        const userInfo = localStorage.getItem("userInfo");
        if (userInfo == null) {
            navigate("/login/KeyStone_Login");
            return;
        } else {
            fetchData();
            getDashboardGroupList();
        }

    }, [reset]);


    const fetchData = async () => {
        setIsLoading(true);
        try {
            const data = await axiosGet(getFillListUrl, {
                /*params: {*/
                actionID: dashboardGroupCountryActionID,
                valueID: 0,
                keyValue: null
                /*},*/
            });
            if (data != null && data.length > 0) {
                setDropdownList(data);
            }
            else {
                console.error("Failed to fetch country list: No data found.");
            }
        }
        catch (error) {
            console.error("Error fetching country list:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const getDashboardGroupList = async () => {
        setIsLoading(true);
        try {
            let resolvedStatus;
            if (status === "Active") {
                resolvedStatus = true;
            } else if (status === "" || status === "0") {
                resolvedStatus = null;
            } else {
                resolvedStatus = false;
            }


            const dashboardGroupSearchParam = {
                dashboardGroupcountryID: countryID > 0 ? countryID.toString() : "0",
                dashboardGroupName: (groupName == "" || groupName == null || groupName == undefined) ? "" : groupName,
                status: resolvedStatus
            };
            const response = await axiosPost(GetDashboardGroupListSearchUrl, dashboardGroupSearchParam);
            if (response) {
                setdashboardGroupList(response);
                setFilteredDashboardGroups(response);
            } else {
                showToast('error', 'Failed to fetch dashboard groups: No data found.');
                console.error("Failed to fetch dashboard groups: No data found.");
            }
        } catch (error) {
            console.error("Error fetching dashboard groups:", error);
        } finally {
            setIsLoading(false);
        }
    };
    const [isDeleteModal, setDeleteModal] = useState(false);
    const [dashboardGroupID, setDashboardGroupID] = useState('');

    const toggleDeleteModal = (dashboardGroupID, dashboardGroup) => {
        if (isDeleteModal) {
            setDeleteModal(false);
            setDashboardGroupID('');
            setdashboardGroup('');
        } else {
            console.log(dashboardGroupID, dashboardGroup)
            setDeleteModal(true);
            setDashboardGroupID(dashboardGroupID);
            setdashboardGroup(dashboardGroup);
        }
    };
    const handleDelete = async (dashboardGroupID) => {
        setIsLoading(true);
        try {
            const response = await axiosDelete(DeleteActionUrl, { moduleID: 5, valueID: dashboardGroupID.toString() });
            if (response) {
                showToast('success', 'Successfully Deleted!');
                getDashboardGroupList();
            } else {
                console.error("Failed to fetch dashboards groups: No data found.");
                showToast('error', 'Failed to fetch dashboard groups: No data found.');
            }
        } catch (error) {
            console.error("Error fetching dashboard groups:", error);
            showToast('error', `Error fetching dashboard groups:, ${error}`)
        } finally {
            setIsLoading(false);
            setDeleteModal(false); // Close the modal after the action
        }
    }
    const searchBtnCall = async () => {
        getDashboardGroupList();
        setReset(false)
    }
    const resetSearch = async () => {
        setcountryID("0");
        setGroupName("");
        setStatus("Active");
        setReset(true)
    }
    const editGroup = async (groupID) => {
        navigate("/dashboard-group-add", { state: { groupID } });
    }

    return (
        <>
            {isLoading ? <Loader /> : <></>}
            <HeaderBlock left="" title={t('dashboardGroup.dashboardGroup')} actions={
                <Button className="add-dashbaord-btn"
                    variant="outlined"
                    startIcon={<i className="fa fa-plus margin-right-xs" />}
                    onClick={() => navigate("/dashboard-group-add")}
                >
                    {t('common.Add')}
                </Button>
            } leftCenterAlign="true" actionsCenterAlign="true" />
            <main
                id="main"
                className="dashboardGroupListMain">
                <Box className="pagetitle main-area-top"
                    textAlign="center">
                    <section className="section page-body">
                        <Box className="margin-top-base margin-bottom-none"
                            sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 2,
                                alignItems: "flex-start",
                            }}
                        >
                            <FormControl className="list-page-control-dashboard-group">
                                {/*<InputLabel>{t('dashboard_group.country')}</InputLabel>*/}
                                {/*<Select id="dropdown"*/}
                                {/*    value={countryID}*/}
                                {/*    onChange={handleChange}>*/}
                                <TextField className="padding-top-s margin-bottom-s text-align-left"
                                    label={t('dashboardGroup.country')}
                                    onChange={handleChange}
                                    value={countryID}
                                    select
                                    fullWidth
                                    variant="outlined"
                                >
                                    <MenuItem key="0" value="0" >
                                        {t('dashboardGroup.selectCountry')}
                                    </MenuItem>
                                    {dropdownList.map((item) => (
                                        //<option key={item.code} value={item.code}>
                                        //    {item.description}
                                        //</option>
                                        <MenuItem key={item.code} value={item.code}>
                                            {item.description}
                                        </MenuItem>
                                    ))}
                                    {/*<MenuItem value="">*/}
                                    {/*    <em>Add Country</em>*/}
                                    {/*</MenuItem>*/}
                                    {/*<MenuItem value="India">India</MenuItem>*/}
                                    {/*<MenuItem value="Singapore">Singapore</MenuItem>*/}
                                </TextField>
                            </FormControl>
                            <FormControl className="list-page-control-dashboard-group">
                                <TextField
                                    className="padding-top-s margin-bottom-s text-align-left"
                                    label={t('dashboardGroup.groupName')}
                                    placeholder={t('dashboardGroup.groupName')}
                                    variant="outlined"
                                    fullWidth
                                    value={groupName}
                                    onChange={handleGroupNameChange}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                            </InputAdornment>
                                        ),
                                    }} />
                            </FormControl>
                            <FormControl className="list-page-control-dashboard-group">
                                <TextField
                                    className="padding-top-s margin-bottom-s text-align-left"
                                    label={t('dashboardGroup.status')}
                                    onChange={handleStatusChange}
                                    value={status}
                                    select
                                    fullWidth
                                    variant="outlined"
                                >
                                    {/*<Select value={status}*/}
                                    {/*    onChange={handleStatusChange}>*/}
                                    <MenuItem value="0">
                                        {t('dashboardGroup.selectStatus')}
                                    </MenuItem>
                                    <MenuItem value="Active">{t("common.active")}</MenuItem>
                                    <MenuItem value="Inactive">{t("common.inactive")}</MenuItem>
                                </TextField>
                            </FormControl>
                            <Button className="margin-left-base margin-right-xs" variant="contained" sx={{ alignSelf: "center" }} onClick={() => searchBtnCall()}>
                                {t('common.search')}
                            </Button>
                            <Button variant="contained" sx={{ alignSelf: "center" }} onClick={() => resetSearch()}>
                                {t('common.reset')}
                            </Button>
                        </Box>

                        <TableContainer component={Paper} className="margin-top-base list-height margin-bottom-xl list-height list-height padding-left-base padding-right-base padding-x-base padding-bottom-base padding-top-none shadow-0 border-light border-radius">
                            <Table>
                                <TableHead>
                                    <TableRow sx={{
                                        borderBottom: "2px solid",
                                        borderColor: "primary.main",
                                    }}>
                                        <TableCell>{t('dashboardGroup.groupName')}</TableCell>
                                        <TableCell>{t('dashboardGroup.country')}</TableCell>
                                        <TableCell>{t('dashboardGroup.status')}</TableCell>
                                        <TableCell align="center">{t('common.Action')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {paginatedDashboardGroups?.length > 0 ? (
                                        paginatedDashboardGroups?.map((dashboardGroup, index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{ width: '20rem', wordWrap: "break-word", whiteSpace: "normal", wordBreak: "break-word" }}>{dashboardGroup.dashboardGroup}</TableCell>
                                                <TableCell>{dashboardGroup.countryName}</TableCell>
                                                <TableCell>{dashboardGroup.status}</TableCell>
                                                <TableCell align="center">
                                                    <Box display="flex" justifyContent="center">
                                                        {/* <IconButton onClick={() => toggleDeleteModal(dashboardGroup.dashboardGroupID, dashboardGroup.dashboardGroup)}>
                                                                                <Delete color="primary" />
                                                                            </IconButton>
                                                                            <IconButton onClick={() => editGroup(dashboardGroup.dashboardGroupID)}>
                                                                                <Edit color="primary" />
                                                                            </IconButton> */}


                                                        <Button className="padding-right-none">
                                                            <Tooltip title="Remove">
                                                                <Icon className='fa-light fa-trash-can font-size-base text-primary' onClick={() => toggleDeleteModal(dashboardGroup.dashboardGroupID, dashboardGroup.dashboardGroup)} />
                                                            </Tooltip>
                                                        </Button>
                                                        <Button className="padding-right-none">
                                                            <Tooltip title="Edit">
                                                                <Icon className='fa-light fa-pen-to-square font-size-base text-primary' onClick={() => editGroup(dashboardGroup.dashboardGroupID)} />
                                                            </Tooltip>
                                                        </Button>


                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))) : (
                                        <TableCell colSpan={4}>{t('common.noRecordsFound')}</TableCell>
                                    )}
                                </TableBody>
                            </Table>
                            <CommonPagination
                                totalItems={totalItems}
                                currentPage={currentPage}
                                onPageChange={setCurrentPage}
                            />
                        </TableContainer>
                        <Dialog className="border-radius-soft padding-y-base padding-x-base text-align-center dashboardGroupListDialog"
                            open={isDeleteModal}>
                            <DialogTitle>
                                <Typography className="margin-bottom-none font-size-h3 text-primary text-align-left "
                                    variant="h6"
                                >
                                    {t('dashboardGroup.deleteDashboardGroup')}
                                    {/*- <strong>{dashboardGroup}</strong>*/}
                                </Typography>
                            </DialogTitle>

                            <DialogContent>
                                <Typography className="margin-bottom-base text-primary font-size-h5 text-align-left">
                                    {t('common.deleteMessage')}
                                </Typography>
                            </DialogContent>

                            <DialogActions className="dialogAction">
                                <Button
                                    variant="outlined"
                                    startIcon={<Cancel />}
                                    onClick={() => toggleDeleteModal('', '')}
                                    className="text-neutral-7 border-size-s border-radius-soft add-dashbaord-btn"
                                >
                                    {t('common.Cancel')}
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={() => handleDelete(dashboardGroupID)}
                                    startIcon={<Delete />}
                                    className=" border-size-s border-radius-soft del-pop-btn add-dashbaord-btn"
                                >
                                    {t('common.Delete')}
                                </Button>
                            </DialogActions>
                        </Dialog>

                    </section>

                </Box>
            </main>
            {ToastComponent}
        </>
        //    </>
        //)}
        /*</>*/
    );
    //}
}

export default withTranslation()(DashboardGroupList);
